import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faPencilAlt, 
  faFileSignature, 
  faHammer, 
  faPaintBrush, 
  faKey 
} from '@fortawesome/free-solid-svg-icons';

const ProcessSteps = () => {
  const steps = [
    {
      id: 1,
      number: "01",
      title: "Consultation",
      description: "Listening to your needs and goals.",
      icon: faUser
    },
    {
      id: 2,
      number: "02",
      title: "Design Drafting",
      description: "Developing creative concepts.",
      icon: faPencilAlt
    },
    {
      id: 3,
      number: "03",
      title: "Blueprints & Approvals",
      description: "Ensuring compliance and clarity.",
      icon: faFileSignature
    },
    {
      id: 4,
      number: "04",
      title: "Construction",
      description: "Managing every step with precision.",
      icon: faHammer
    },
    {
      id: 5,
      number: "05",
      title: "Finishing Touches",
      description: "Adding details that elevate the experience.",
      icon: faPaintBrush
    },
    {
      id: 6,
      number: "06",
      title: "Final Handover",
      description: "Delivering a space that exceeds expectations.",
      icon: faKey
    }
  ];

  return (
    <div className="w-full px-4 py-8 bg-white" >
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
          Our Process
        </h2>
        
        <div className="relative">
          {/* Connecting line */}
          <div className="absolute left-4 right-4 top-8 h-0.5 bg-gray-300 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6 relative z-10">
            {steps.map((step, index) => (
              <div 
                key={step.id} 
                className="flex flex-col items-center text-center group"
              >
                {/* Step circle with icon */}
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-yellow-500 to-yellow-600 flex items-center justify-center mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                  <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center">
                    <FontAwesomeIcon 
                      icon={step.icon} 
                      className="text-yellow-600 text-xl"
                    />
                  </div>
                </div>

                {/* Step number */}
                <div className="text-2xl font-bold text-gray-700 mb-2">
                  {step.number}
                </div>

                {/* Step title */}
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {step.title}
                </h3>

                {/* Step description */}
                <p className="text-gray-600 text-sm leading-relaxed px-2">
                  {step.description}
                </p>

                {/* Connector dots for mobile view */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block lg:hidden xl:hidden">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-4"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSteps;